module.exports = __webpack_public_path__ + "static/media/shopping_basket.ed0063c3.svg";